export default __webpack_public_path__ + "static/media/project15.b23dc02d.webp";